// extracted by mini-css-extract-plugin
export var button = "Button-module--button--45b1e";
export var outlined = "Button-module--outlined--d2879";
export var secondary = "Button-module--secondary--d05b6";